module.exports = __webpack_public_path__ + "img/rs_blackwhiteT-logo.5e24b87.png";